import { getReceiptDate } from "../../utils/receiptDate";
import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Button,
  IconButton,
  Box,
  Typography,
  Paper,
  TextField,
  Snackbar,
  Alert,
  InputAdornment,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PrintIcon from "@mui/icons-material/Print";
import SearchIcon from "@mui/icons-material/Search";
import StorefrontIcon from "@mui/icons-material/Storefront";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import { useParams, useNavigate } from "react-router-dom";
import { TRUNG_THU_LOAI_BANH, TRUNG_THU_LOAI_PHIEU } from "../../constants/trungThu";
import TrungThuQrScannerModal from "./TrungThuQrScannerModal";

const toValidStoreId = (value) => {
  if (value === null || value === undefined || String(value).trim() === "") {
    return null;
  }
  const numericValue = Number(value);
  return Number.isInteger(numericValue) && numericValue > 0 ? numericValue : null;
};

const getReceiptItemKey = (item) => {
  const detailId = item?.idNhapCT ?? item?.IDNhapCT;
  if (detailId !== undefined && detailId !== null && String(detailId).trim() !== "") {
    return `id:${detailId}`;
  }

  return `item:${item?.maVt || item?.MaSP || ""}__${String(item?.loSX || item?.LoSX || "").trim()}`;
};

// Base receipt template without items
const receiptTemplate = {
  id: null,
  soPhieu: "",
  ngay: new Date(),
  khachHang: "",
  trangThai: "Chờ xác nhận",
  tongSoLuong: 0,
  items: [],
};

const NewPhieuNhapTT = () => {
  const { id, action } = useParams();
  const navigate = useNavigate();
  const [receipt, setReceipt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [storeName, setStoreName] = useState("");
  const [storeId, setStoreId] = useState("");
  const [stores, setStores] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [note, setNote] = useState("");
  const [customerOrderName, setCustomerOrderName] = useState("");
  const [qrScannerOpen, setQrScannerOpen] = useState(false);
  const [qrProcessing, setQrProcessing] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [highlightedItems, setHighlightedItems] = useState([]);
  const [currentHighlightIndex, setCurrentHighlightIndex] = useState(-1);
  const [showScrollButtons, setShowScrollButtons] = useState(false);
  const bottomRef = useRef(null);
  const [showScrollToBottom, setShowScrollToBottom] = useState(false);
  const qrInputRef = useRef(null);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [storeSearchTerm, setStoreSearchTerm] = useState("");
  const [quickQrInput, setQuickQrInput] = useState("");

  // Add new state for edit mode
  const [isEditMode, setIsEditMode] = useState(false);
  const [originalReceiptNumber, setOriginalReceiptNumber] = useState("");
  const [originalItems, setOriginalItems] = useState([]);

  const getCurrentUserStoreId = () => {
    const userStoreId = localStorage.getItem("IDCH");
    return userStoreId && String(userStoreId).trim() ? String(userStoreId).trim() : "20";
  };

  const getSourceStoreId = (destinationStoreId, ghiChu = "") => {
    const destination = String(destinationStoreId || "").trim();
    const currentUserStore = getCurrentUserStoreId();
    const normalizedNote = String(ghiChu || "").trim().toLowerCase();
    const isTransferOrReturn =
      normalizedNote.includes("dieuchuyen") ||
      normalizedNote.includes("trave") ||
      normalizedNote.includes("tra hủy") ||
      normalizedNote.includes("tra huy") ||
      destination === "444";

    if (isTransferOrReturn || destination !== "20") {
      return currentUserStore;
    }

    return "20";
  };

  const getStoreDisplayName = (store) => {
    if (!store) return "";
    return String(
      store.TenCuaHang ||
        store.TenCuaHang_Uni ||
        store.Ten_CH ||
        store.TenCH ||
        store.MaBravo ||
        store.IDCH ||
        ""
    ).trim();
  };

  // Fetch stores
  useEffect(() => {
    const fetchStores = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/stores`);
        if (!response.ok) throw new Error("API error");
        const storesData = await response.json();

        // Add the custom store option
        const customStore = {
          IDCH: 222,
          TenCuaHang: "Khách hàng"
        };
         const customStore2 = {
          IDCH: 333,
          TenCuaHang: "Biếu tặng"
        };
        const customStore3 = {
          IDCH: 444,
          TenCuaHang: "Trả Hủy"
        };
        const customStore4 = {
          IDCH: 555,
          TenCuaHang: "Kho DC"
        };
        const customStore5 = {
          IDCH: 666,
          TenCuaHang: "Kho Thanh Lý"
        };

        // Combine API stores with custom store
        const allStores = [...storesData, customStore, customStore2, customStore3, customStore4, customStore5];
        setStores(allStores);
      } catch (e) {
        // If API fails, still add the custom store
        const customStore = {
          IDCH: 222,
          TenCuaHang: "Khách hàng"
        };
        const customStore2 = {
          IDCH: 333,
          TenCuaHang: "Biếu tặng"
        };
        const customStore3 = {
          IDCH: 444,
          TenCuaHang: "Trả Hủy"
        };
        const customStore4 = {
          IDCH: 555,
          TenCuaHang: "Kho DC"
        };
        const customStore5 = {
          IDCH: 666,
          TenCuaHang: "Kho Thanh Lý"
        };
        setStores([customStore, customStore2, customStore3, customStore4, customStore5]);

        setSnackbarMessage("Không thể tải danh sách cửa hàng");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    };
    fetchStores();
  }, []);

  // Init receipt
  useEffect(() => {
    const initializeReceipt = async () => {
      setLoading(true);

      // Check if we're editing an existing receipt
      if (id && action === "edit") {
        setIsEditMode(true);
        try {
          // Fetch receipt details first to get MaCH
          const { items, ghiChu, maCH } = await fetchReceiptDetailsForEdit(id);

          // Find the corresponding store from stores list using MaCH
          let tenCuaHang = "";
          let idCuaHang = "";

          if (maCH && stores.length > 0) {
            const matchingStore = stores.find(
              (store) => String(store.IDCH ?? "") === String(maCH)
            );
            if (matchingStore) {
              tenCuaHang = getStoreDisplayName(matchingStore);
              idCuaHang = String(matchingStore.IDCH ?? "");
              setStoreName(tenCuaHang);
              setStoreId(idCuaHang);
            }
          }

          // Generate receipt number for editing
          const editReceiptNumber = `DTTT/BN-${String(id).padStart(7, "0")}`;
          setOriginalReceiptNumber(editReceiptNumber);

          setReceipt({
            ...receiptTemplate,
            id: parseInt(id),
            soPhieu: editReceiptNumber,
            khachHang: tenCuaHang || "",
            maCH,
            items: items,
            trangThai: "Chờ cập nhật",
            ghiChu: ghiChu,
          });
          setOriginalItems(JSON.parse(JSON.stringify(items)));
          setNote(ghiChu);
          setLoading(false);
          return;
        } catch (error) {
          console.error("Error loading receipt for editing:", error);
          setApiError("Không thể tải dữ liệu phiếu nhập để chỉnh sửa");
          setLoading(false);
          return;
        }
      }

      // For new receipts
      setIsEditMode(false);
      const nextId = Math.floor(Math.random() * 1000000);
      setReceipt({
        ...receiptTemplate,
        ngay: new Date(),
        id: nextId,
        soPhieu: `DTTT/BN-${String(nextId).padStart(7, "0")}`,
        khachHang: "",
        items: [],
        ghiChu: "",
      });
      setOriginalItems([]);
      setNote("");
      setLoading(false);
    };

    // Only initialize if stores are loaded
    if (stores.length > 0 || (!id || action !== "edit")) {
      initializeReceipt();
    }
    setIsAdmin(localStorage.getItem("isAdmin") === "true");
  }, [id, action, stores]); // Add stores as dependency

  // QR scan handler
  const processQRCode = async (
    qrData,
    { showErrorModal = true, quantityOverride } = {}
  ) => {
    setQrProcessing(true);
    try {
      let loSX = "";
      let quantity = 1; // Default quantity

      // Parse quantity and LoSX from input string
      if (qrData.includes("doticom.vn/t.php?c=")) {
        // Check if there's a quantity prefix (e.g., "10https://doticom.vn/t.php?c=509")
        const urlMatch = qrData.match(/(\d*)https?:\/\/doticom\.vn\/t\.php\?c=(\d+)/);
        if (urlMatch) {
          const quantityPrefix = urlMatch[1];
          loSX = urlMatch[2];
          if (quantityPrefix && quantityPrefix.length > 0) {
            quantity = parseInt(quantityPrefix, 10) || 1;
          }
        } else {
          // Fallback to original URL parsing
          const match = qrData.match(/c=(\d+)/);
          if (match) loSX = match[1];
        }
      } else if (/^\d+$/.test(qrData.trim())) {
        // Pure numeric string (LoSX only)
        loSX = qrData.trim();
        quantity = 1;
      } else {
        // Check if it's a quantity + LoSX combination without URL
        const numericMatch = qrData.match(/^(\d+)(\d{2,})$/);
        if (numericMatch && numericMatch[2].length >= 2) {
          // If second group has at least 2 digits, treat first as quantity
          quantity = parseInt(numericMatch[1], 10) || 1;
          loSX = numericMatch[2];
        } else {
          // Fallback: treat entire string as LoSX
          loSX = qrData.trim();
        }
      }

      if (quantityOverride !== undefined) {
        const normalizedQuantity = Number(quantityOverride);
        if (!Number.isInteger(normalizedQuantity) || normalizedQuantity <= 0) {
          throw new Error("Số lượng quét phải là số nguyên lớn hơn 0");
        }
        quantity = normalizedQuantity;
      }

      if (!loSX) throw new Error("Không thể trích xuất mã LoSX từ QR code");

      // Call QRTrungThu API
      const qrRes = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/QRTrungThu?LoSX=${loSX}`
      );
      if (!qrRes.ok) throw new Error("Lỗi API QRTrungThu");
      let qrItems = await qrRes.json();

      // Ensure qrItems is always an array
      if (!Array.isArray(qrItems)) {
        if (qrItems && typeof qrItems === "object") {
          qrItems = [qrItems];
        } else {
          qrItems = [];
        }
      }

      if (!qrItems || qrItems.length === 0)
        throw new Error("Không tìm thấy sản phẩm với mã LoSX này");

      for (const qrItem of qrItems) {
        const { MaSP, GiaMua } = qrItem;
        const itemRes = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/items/${MaSP}`
        );
        const itemData = itemRes.ok ? await itemRes.json() : [];
        const Ten_SP = itemData[0]?.Ten_SP || `Sản phẩm ${MaSP}`;
        setReceipt((prev) => {
          if (!prev) return prev;
          const idx = prev.items.findIndex(
            (item) => item.maVt === MaSP && String(item.loSX || "") === String(loSX || "")
          );
          let updatedItems;
          if (idx >= 0) {
            updatedItems = [...prev.items];
            updatedItems[idx] = {
              ...updatedItems[idx],
              soLuong: (parseInt(updatedItems[idx].soLuong) || 0) + quantity,
              loSX,
            };
          } else {
            updatedItems = [
              ...prev.items,
              {
                maVt: MaSP,
                ten: Ten_SP,
                soLuong: quantity,
                dvt: "cái",
                giaMua: GiaMua || 0,
                isQRAdded: true,
                loSX: loSX, // Store LoSX for this specific product
              },
            ];
          }
          return { ...prev, items: updatedItems };
        });
      }
      const successMessage = `Đã thêm ${qrItems.length} sản phẩm với số lượng ${quantity} từ QR code (LoSX: ${loSX})`;
      setSnackbarMessage(successMessage);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      return { success: true, message: successMessage };
    } catch (error) {
      const errorMessage = `Lỗi xử lý QR code: ${error.message}`;
      if (showErrorModal) {
        setErrorModalMessage(errorMessage);
        setErrorModalOpen(true);
      }
      return { success: false, message: errorMessage };
    } finally {
      setQrProcessing(false);
    }
  };

  // Remove item
  const removeItem = (index) => {
    setReceipt((prev) => {
      if (!prev) return prev;
      const updatedItems = prev.items.filter((_, i) => i !== index);
      return { ...prev, items: updatedItems };
    });
    setSnackbarMessage("Đã xóa sản phẩm khỏi phiếu");
    setSnackbarSeverity("info");
    setSnackbarOpen(true);
  };

  // Store select
  const handleStoreSelect = (event) => {
    const selectedStoreId = event.target.value;
    const selectedStore = stores.find(
      (store) => String(store.IDCH) === String(selectedStoreId)
    );
    if (selectedStore) {
      const nextStoreName = getStoreDisplayName(selectedStore);
      setStoreId(String(selectedStoreId));
      setStoreName(nextStoreName);
      setReceipt((prev) =>
        prev ? { ...prev, khachHang: nextStoreName } : prev
      );
      // Clear store search when a store is selected
      setStoreSearchTerm("");
    }
  };

  // Filter stores based on search term
  const filteredStores = stores.filter((store) => {
    if (!storeSearchTerm) return true;
    const searchLower = storeSearchTerm.toLowerCase();
    const storeName = getStoreDisplayName(store).toLowerCase();
    const storeNameUni = String(store.TenCuaHang_Uni ?? "").toLowerCase();
    const maBravo = String(store.MaBravo ?? "").toLowerCase();
    const storeIdValue = String(store.IDCH ?? "").toLowerCase();
    return (
      storeName.includes(searchLower) ||
      storeNameUni.includes(searchLower) ||
      maBravo.includes(searchLower) ||
      storeIdValue.includes(searchLower)
    );
  });

  // Search
  const handleSearchChange = (e) => {
    const newSearchTerm = String(e.target.value ?? "").toLowerCase();
    setSearchTerm(newSearchTerm);
    if (newSearchTerm && receipt && receipt.items) {
      const matchingItems = receipt.items
        .map((item, index) => {
          const maVtMatch = String(item.maVt ?? "")
            .toLowerCase()
            .includes(newSearchTerm);
          const tenMatch = String(item.ten ?? "")
            .toLowerCase()
            .includes(newSearchTerm);
          if (maVtMatch || tenMatch) return { item, index };
          return null;
        })
        .filter(Boolean);
      setHighlightedItems(matchingItems);
      setCurrentHighlightIndex(matchingItems.length > 0 ? 0 : -1);
      setShowScrollButtons(matchingItems.length > 1);
      if (matchingItems.length > 0)
        setTimeout(() => scrollToHighlightedItem(0), 100);
    } else {
      setHighlightedItems([]);
      setCurrentHighlightIndex(-1);
      setShowScrollButtons(false);
    }
  };
  const scrollToHighlightedItem = (highlightIndex) => {
    if (highlightIndex < 0 || highlightIndex >= highlightedItems.length) return;
    const itemIndex = highlightedItems[highlightIndex].index;
    const tableRow = document.querySelector(
      `tr[data-item-index="${itemIndex}"]`
    );
    if (tableRow) {
      tableRow.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
      tableRow.classList.add("scroll-highlight");
      setTimeout(() => {
        tableRow.classList.remove("scroll-highlight");
      }, 1000);
    }
  };
  const scrollToNext = () => {
    if (highlightedItems.length === 0) return;
    const nextIndex = (currentHighlightIndex + 1) % highlightedItems.length;
    setCurrentHighlightIndex(nextIndex);
    scrollToHighlightedItem(nextIndex);
  };
  const scrollToPrevious = () => {
    if (highlightedItems.length === 0) return;
    const prevIndex =
      currentHighlightIndex === 0
        ? highlightedItems.length - 1
        : currentHighlightIndex - 1;
    setCurrentHighlightIndex(prevIndex);
    scrollToHighlightedItem(prevIndex);
  };
  const highlightMatchingItems = (item, index) => {
    if (!searchTerm) return false;
    const maVtMatch = String(item.maVt ?? "")
      .toLowerCase()
      .includes(searchTerm);
    const tenMatch = String(item.ten ?? "")
      .toLowerCase()
      .includes(searchTerm);
    return maVtMatch || tenMatch;
  };

  // Confirm action (gửi phiếu/bqd)
  const confirmAction = async (button, message, isBqdAction = false) => {
    if (button.classList.contains("confirmed")) return;
    if (!storeId) {
      setErrorModalMessage("Vui lòng chọn cửa hàng trước khi xác nhận!");
      setErrorModalOpen(true);
      return;
    }
    if (!receipt.khachHang) {
      setErrorModalMessage("Vui lòng nhập tên khách hàng");
      setErrorModalOpen(true);
      return;
    }
    let totalQty = 0;
    const updatedItems = receipt.items.map((item) => {
      if (item.soLuong) {
        const qty = parseInt(item.soLuong, 10);
        if (!isNaN(qty)) totalQty += qty;
      }
      return item;
    });
    if (totalQty === 0) {
      setErrorModalMessage(
        isEditMode
          ? "Vui lòng nhập số lượng cho ít nhất một sản phẩm"
          : "Vui lòng quét QR code để thêm sản phẩm vào phiếu"
      );
      setErrorModalOpen(true);
      return;
    }

    // Set submitting state
    setSubmitting(true);
    button.disabled = true;
    button.textContent = isBqdAction ? "Đang xử lý..." : "Đang gửi phiếu...";

    try {
      const now = new Date();
      const newTrangThai = isBqdAction ? "Đã duyệt" : "Đã gửi phiếu";

      if (isEditMode) {
        // Call update API for edit mode
        await updateReceiptViaAPI();
      } else {
        // Call create API for new mode
        // Prepare request body for nhap-hang API
        const requestBody = {
          LoaiBanh: TRUNG_THU_LOAI_BANH,
          LoaiPhieu: TRUNG_THU_LOAI_PHIEU,
          phieu: {
            MaKH: storeId.toString(),
            TenKH: customerOrderName.trim(),
            NgayNhap: getReceiptDate(),
            TenUser: localStorage.getItem("TenUser") || "User",
            GhiChu: note || `Nhập bánh trung thu. Số: ${receipt.soPhieu}`,
            Status: storeId.toString() === "20" ? 1 : 2 || 77,
            LoaiPhieu: TRUNG_THU_LOAI_PHIEU,
            LoaiBanh: TRUNG_THU_LOAI_BANH,
            MaCH: storeId.toString(),
            MaCH_DC: getSourceStoreId(storeId, note),
          },
          chitiet: updatedItems.map((item) => ({
            MaSP: item.maVt,
            TenSP: item.ten,
            SoLuong: parseInt(item.soLuong, 10) || 0,
            SoLuongTN: storeId.toString() === "20" ? parseInt(item.soLuong, 10) || 0 : 0,
            SoLuongNhapDau: parseInt(item.soLuong, 10),
            GiaMua: item.giaMua || 0,
            GiamPT: 0,
            ThanhTien: parseInt(item.soLuong, 10) * (item.giaMua || 0),
            LoSX: item.loSX || "",
            LoaiBanh: TRUNG_THU_LOAI_BANH,
            LoaiPhieu: TRUNG_THU_LOAI_PHIEU,
          })),
        };

        // Call the API
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/nhap-hang`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error(`API Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        if (storeId === "20" || storeId == 20) {
          try {
            const xacNhanBody = {
              LoaiBanh: TRUNG_THU_LOAI_BANH,
              LoaiPhieu: TRUNG_THU_LOAI_PHIEU,
              maPhieuNhap: result.MaPhieuNhap.replace(/^PN/, "") || String(Math.floor(Math.random() * 1000)).padStart(3, "0"),
              chiTietSanPham: updatedItems.map((item) => ({
                maSP: item.maVt,
                slThucNhan: parseInt(item.soLuong, 10) || 0,
                LoSX: item.loSX || "",
                LoaiBanh: TRUNG_THU_LOAI_BANH,
                LoaiPhieu: TRUNG_THU_LOAI_PHIEU,
              })),
            };

            const xacNhanResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/xac-nhan-kiem-soat`, {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(xacNhanBody),
            });

            if (!xacNhanResponse.ok) {
              console.warn("Warning: xac-nhan-kiem-soat API failed", xacNhanResponse.status);
            }
          } catch (xacNhanError) {
            console.warn("Warning: xac-nhan-kiem-soat API error", xacNhanError);
          }
        }
      }

      // Update UI on success
      button.textContent = "✓ Đã xác nhận";
      button.classList.add("confirmed");
      const statusDiv = button.nextElementSibling;
      statusDiv.textContent = message + "\n" + now.toLocaleString("vi-VN");
      statusDiv.style.color = "#2196F3";
      statusDiv.style.fontWeight = "bold";

      // Update receipt state
      setReceipt({
        ...receipt,
        items: updatedItems,
        tongSoLuong: totalQty,
        trangThai: newTrangThai,
        ngayXacNhan: now,
        idCuaHang: storeId,
        bqdApproved: isBqdAction ? true : false,
        bqdTimestamp: isBqdAction ? now : null,
        bqdMessage: isBqdAction ? message : null,
        lastUpdated: now,
        updateCount: isEditMode ? (receipt.updateCount || 0) + 1 : 1,
      });

      // Show success message
      setSnackbarMessage(
        isEditMode
          ? "Cập nhật phiếu nhập bánh trung thu thành công!"
          : isBqdAction
            ? "Đã xác nhận kiểm soát BQD!"
            : "Đã gửi phiếu nhập bánh trung thu thành công!"
      );
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error submitting receipt:", error);

      // Reset button state on error
      button.disabled = false;
      button.textContent = isBqdAction
        ? "Xác nhận kiểm soát"
        : isEditMode
          ? "Cập nhật phiếu"
          : "Xác nhận gửi phiếu";

      // Show error modal
      setErrorModalMessage(
        `Lỗi khi ${isEditMode ? "cập nhật" : isBqdAction ? "xác nhận kiểm soát" : "gửi phiếu"}: ${error.message
        }`
      );
      setErrorModalOpen(true);
    } finally {
      setSubmitting(false);
    }
  };

  // Scroll to bottom button
  useEffect(() => {
    const handleScroll = () => {
      if (receipt && receipt.items && receipt.items.length > 10) {
        const scrollY = window.scrollY || window.pageYOffset;
        const windowHeight = window.innerHeight;
        const docHeight = document.documentElement.scrollHeight;
        setShowScrollToBottom(docHeight - (scrollY + windowHeight) > 120);
      } else {
        setShowScrollToBottom(false);
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [receipt]);

  // Chỉ tự động focus QR input khi cửa hàng được chọn/khởi tạo.
  // Không phụ thuộc receipt.items vì mỗi lần nhập số lượng đều cập nhật mảng này.
  useEffect(() => {
    if (storeId && qrInputRef.current) {
      qrInputRef.current.focus();
    }
  }, [storeId]);

  const focusQrInput = () => {
    window.requestAnimationFrame(() => qrInputRef.current?.focus());
  };

  const handleQuantityKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      focusQrInput();
    }
  };

  const handleQuantityBlur = (event) => {
    const nextFocusTarget = event.relatedTarget;
    if (!nextFocusTarget || nextFocusTarget === document.body) {
      focusQrInput();
    }
  };

  // Add handleAddProduct function
  const handleAddProduct = async () => {
    if (!quickQrInput.trim()) {
      setErrorModalMessage("Vui lòng nhập mã QR hoặc LoSX");
      setErrorModalOpen(true);
      return;
    }

    const qrValue = quickQrInput.trim();
    setQuickQrInput("");
    await processQRCode(qrValue);
    focusQrInput();
  };

  // Xử lý nhập QR trực tiếp từ input và nhấn Enter
  const handleQuickQRInput = async (e) => {
    if (e.key !== "Enter") return;

    e.preventDefault();
    const qrValue = e.target.value.trim();
    if (!qrValue) {
      focusQrInput();
      return;
    }

    setQuickQrInput("");
    await processQRCode(qrValue);
    focusQrInput();
  };

  // Function to fetch receipt details for editing
  const fetchReceiptDetailsForEdit = async (maPN) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/sale-nhap-hang-detail/${maPN}`
      );
      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
      }
      const data = await response.json();
      console.log("📋 Receipt Details from API for editing:", data);

      // API returns object with Items array
      const items = data[0].Items || [];
      console.log("📋 Items array from receipt details:", items);

      const mappedReceiptDetails = items.map((item) => ({
        idNhapCT: item.IDNhapCT,
        maVt: item.MaSP,
        ten: item.TenSP,
        soLuong: item.SLNhapDau || item.SLThucNhan, // Use SLNhapDau first, fallback to SLThucNhan
        dvt: item.DVT || "cái",
        giaMua: item.GiaMua,
        giamPT: item.GiamPT || 0,
        thanhTien: item.ThanhTien,
        isQRAdded: true, // Mark as QR added for consistency
        loSX: item.LoSX || "", // Include LoSX if available
        originalSoLuong: item.SLNhapDau || item.SLThucNhan || 0,
      }));

      console.log("📋 Mapped Receipt Details for editing:", mappedReceiptDetails);

      // Get note and MaCH from receipt details
      const ghiChu = data[0]?.GhiChu || "";
      const maCH = data[0]?.MaCH || "";

      return { items: mappedReceiptDetails, ghiChu, maCH };
    } catch (error) {
      console.error("Error fetching receipt details for editing:", error);
      return { items: [], ghiChu: "", maCH: "" };
    }
  };

  // Function to update existing receipt via API
  const updateReceiptViaAPI = async () => {
    try {
      // Filter only items that have a quantity value
      const itemsToUpdate = receipt.items.filter(
        (item) => item.soLuong && parseInt(item.soLuong, 10) > 0
      );
      const currentItemKeys = new Set(itemsToUpdate.map(getReceiptItemKey));
      const deletedItems = originalItems.filter((originalItem) => {
        const hadQuantity =
          (parseInt(originalItem.originalSoLuong, 10) ||
            parseInt(originalItem.soLuong, 10) ||
            0) > 0;

        return hadQuantity && !currentItemKeys.has(getReceiptItemKey(originalItem));
      });

      if (itemsToUpdate.length === 0 && deletedItems.length === 0) {
        setErrorModalMessage("Không có sản phẩm nào để cập nhật!");
        setErrorModalOpen(true);
        throw new Error("Khong co san pham nao de cap nhat");
      }

      const maCHCT = toValidStoreId(storeId || receipt?.maCH);
      if (maCHCT === null) {
        setErrorModalMessage("Mã cửa hàng của phiếu nhập không hợp lệ, không thể cập nhật!");
        setErrorModalOpen(true);
        throw new Error("Ma cua hang cua phieu nhap khong hop le");
      }

      // Format the request body according to API requirements
      const requestBody = {
        MaCH: maCHCT,
        MaCH_CT: maCHCT,
        LoaiBanh: TRUNG_THU_LOAI_BANH,
        LoaiPhieu: TRUNG_THU_LOAI_PHIEU,
        DeletedItems: deletedItems.map((item) => ({
          IDNhapCT: item.idNhapCT || item.IDNhapCT || null,
          MaSP: item.maVt,
          LoSX: item.loSX || "",
        })),
        Items: itemsToUpdate.map((item) => ({
          IDNhapCT: item.idNhapCT || item.IDNhapCT || null,
          MaSP: item.maVt,
          TenSP: item.ten,
          SoLuong: parseInt(item.soLuong, 10),
          SLThucNhan: (String(maCHCT) === "20" || String(maCHCT) === "222")
            ? parseInt(item.soLuong, 10) || 0
            : 0,
          SoLuongNhapDau: parseInt(item.soLuong, 10),
          GiaMua: item.giaMua || 0,
          GiamPT: item.giamPT || 0,
          ThanhTien: parseInt(item.soLuong, 10) * (item.giaMua || 0),
          LoSX: item.loSX || "",
          MaCH: maCHCT,
          MaCH_CT: maCHCT,
          LoaiBanh: TRUNG_THU_LOAI_BANH,
          LoaiPhieu: TRUNG_THU_LOAI_PHIEU,
        })),
        GhiChu: note || "",
      };

      console.log("🔄 Updating receipt with ID:", id);
      console.log("🔄 Request body:", requestBody);

      // Call the update API
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/sale-nhap-hang/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update receipt");
      }

      const data = await response.json();
      setSnackbarMessage("Cập nhật phiếu nhập bánh trung thu thành công!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      // Wait a moment before redirecting
      setTimeout(() => {
        navigate("/nhaphangtt");
      }, 2000);
    } catch (error) {
      setErrorModalMessage(
        `Có lỗi xảy ra khi cập nhật phiếu nhập: ${error.message}`
      );
      setErrorModalOpen(true);
      console.error("Error updating receipt via API:", error);
      throw error;
    }
  };

  if (loading)
    return (
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
          flexDirection: "column",
        }}
      >
        <CircularProgress sx={{ mb: 2 }} />
        <Typography>Đang tải dữ liệu phiếu nhập bánh trung thu...</Typography>
      </Container>
    );
  if (apiError)
    return (
      <Container maxWidth="lg">
        <Alert severity="error" sx={{ mt: 2 }}>
          Có lỗi khi tải dữ liệu: {apiError}.
        </Alert>
      </Container>
    );
  if (!receipt)
    return (
      <Container maxWidth="lg">
        <Typography>Không tìm thấy phiếu nhập</Typography>
      </Container>
    );

  const day = receipt.ngay.getDate();
  const month = receipt.ngay.getMonth() + 1;
  const year = receipt.ngay.getFullYear();
  const getReceiptStatus = () =>
    receipt.trangThai === "Hoàn thành"
      ? "Hoàn thành"
      : receipt.bqdApproved
        ? "Đã duyệt"
        : "Đã gửi phiếu";

  // Add pageTitle definition
  const pageTitle = isEditMode ? "Chỉnh sửa phiếu bánh trung thu" : "Phiếu điều phối bánh trung thu";

  return (
    <Box>
      <Box
        sx={{
          p: { xs: 1, sm: 2 },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "stretch", sm: "center" },
          gap: { xs: 1, sm: 0 },
          "@media print": { display: "none" },
        }}
      >
        <Box display="flex" alignItems="center" sx={{ mb: { xs: 1, sm: 0 } }}>
          <IconButton
            sx={{ mr: 1, p: { xs: 1, sm: 1.5 } }}
            onClick={() => navigate("/nhaphangtt")}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="h1"
            sx={{ fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.25rem" } }}
          >
            {pageTitle}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            startIcon={<PrintIcon />}
            variant="contained"
            color="primary"
            size="small"
            sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
            onClick={() => window.print()}
          >
            In
          </Button>
        </Box>
      </Box>

      {/* Store selection - only show for new receipts or when no store is set in edit mode */}
      {(!isEditMode || !storeId) && (
        <Box
          sx={{ p: { xs: 1, sm: 2 }, mb: 2, "@media print": { display: "none" } }}
        >
          <Paper sx={{ p: 2 }}>
            <Typography
              variant="h6"
              sx={{ mb: 2, fontSize: { xs: "1rem", sm: "1.25rem" } }}
            >
              {isEditMode ? "Chọn cửa hàng (để cập nhật)" : "Chọn cửa hàng"}
            </Typography>

            {/* Store search input */}
            <TextField
              fullWidth
              size="small"
              label="Tìm kiếm cửa hàng"
              placeholder="Nhập tên cửa hàng hoặc ID..."
              value={storeSearchTerm}
              onChange={(e) => setStoreSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 2 }}
            />

            <FormControl fullWidth size="small">
              <InputLabel id="store-select-label">Chọn cửa hàng</InputLabel>
              <Select
                labelId="store-select-label"
                value={storeId}
                label="Chọn cửa hàng"
                onChange={handleStoreSelect}
                required
              >
                <MenuItem value="">
                  <em>-- Chọn cửa hàng --</em>
                </MenuItem>
                {filteredStores.map((store) => (
                  <MenuItem key={store.IDCH} value={store.IDCH}>
                    {getStoreDisplayName(store)} ({store.IDCH})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              fullWidth
              size="small"
              label="Tên khách đặt/ mã đơn đặt"
              placeholder="Nhập tên khách đặt hoặc mã đơn đặt..."
              value={customerOrderName}
              onChange={(e) => setCustomerOrderName(e.target.value)}
              sx={{ mt: 2 }}
            />

            {storeSearchTerm && filteredStores.length === 0 && (
              <Typography
                variant="caption"
                color="warning.main"
                sx={{ mt: 1, display: "block" }}
              >
                Không tìm thấy cửa hàng nào phù hợp
              </Typography>
            )}

            {!storeId && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mt: 1, display: "block" }}
              >
                * Vui lòng chọn cửa hàng để tiếp tục
              </Typography>
            )}
          </Paper>
        </Box>
      )}

      {/* Store info */}
      {storeName && (
        <Box
          sx={{
            p: { xs: 1, sm: 1 },
            mx: { xs: 1, sm: 0 },
            mb: 2,
            backgroundColor: "#e3f2fd",
            display: "flex",
            alignItems: "center",
            borderRadius: 1,
            "@media print": { display: "none" },
          }}
        >
          <StorefrontIcon
            sx={{
              mr: 1,
              color: "#1976d2",
              fontSize: { xs: "1rem", sm: "1.25rem" },
            }}
          />
          <Typography sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}>
            Cửa hàng: <strong>{storeName}</strong>
            {storeId && <span> (ID: {storeId})</span>}
          </Typography>
        </Box>
      )}
      {/* QR Scanner and Search */}
      <Box
        sx={{
          p: { xs: 1, sm: 2 },
          mb: { xs: 2, sm: 3 },
          "@media print": { display: "none" },
          position: "sticky",
          top: 0,
          backgroundColor: "white",
          zIndex: 1201,
          boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
          borderRadius: "0 0 8px 8px",
          transition: "box-shadow 0.3s ease",
        }}
      >
        {storeId && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {/* QR input - show different placeholder for edit mode */}
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              <TextField
                inputRef={qrInputRef}
                variant="outlined"
                label={isEditMode ? "Quét QR để thêm/cập nhật sản phẩm" : "Quét QR hoặc nhập mã LoSX"}
                placeholder={isEditMode ? "Quét QR để thêm sản phẩm mới hoặc cập nhật số lượng..." : "Quét hoặc nhập mã QR/LoSX, nhấn Enter..."}
                size="small"
                value={quickQrInput}
                onChange={(e) => setQuickQrInput(e.target.value)}
                sx={{
                  flex: "1 1 320px",
                  minWidth: { xs: "100%", sm: "320px" },
                  "& .MuiInputBase-input": {
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                  },
                }}
                onKeyDown={handleQuickQRInput}
                disabled={qrProcessing}
                autoFocus
              />
              <Button
                variant="contained"
                color="primary"
                startIcon={<QrCodeScannerIcon />}
                onClick={() => setQrScannerOpen(true)}
                disabled={qrProcessing}
                sx={{ whiteSpace: "nowrap", px: 2 }}
              >
                Quét QR
              </Button>
              {/* Nút "Thêm" có icon Enter */}
              <Button
                variant="outlined"
                color="primary"
                onClick={handleAddProduct}
                disabled={qrProcessing}
                sx={{ whiteSpace: "nowrap", px: 2 }}
              >
                <KeyboardReturnIcon sx={{ mr: 1 }} />
                Thêm
              </Button>
            </Box>
            <Box sx={{ position: "relative" }}>
              <TextField
                fullWidth
                variant="outlined"
                label="Tìm kiếm sản phẩm đã thêm"
                placeholder="Nhập mã sản phẩm hoặc tên sản phẩm..."
                value={searchTerm}
                onChange={handleSearchChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                size="small"
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                  },
                }}
              />
              {showScrollButtons && (
                <Box
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    borderRadius: 1,
                    padding: "4px 8px",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{ fontSize: "0.75rem", minWidth: "40px" }}
                  >
                    {currentHighlightIndex + 1}/{highlightedItems.length}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={scrollToPrevious}
                    sx={{ p: 0.5, "& .MuiSvgIcon-root": { fontSize: "1rem" } }}
                    title="Kết quả trước"
                  >
                    <ArrowBackIcon sx={{ transform: "rotate(90deg)" }} />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={scrollToNext}
                    sx={{ p: 0.5, "& .MuiSvgIcon-root": { fontSize: "1rem" } }}
                    title="Kết quả tiếp theo"
                  >
                    <ArrowBackIcon sx={{ transform: "rotate(-90deg)" }} />
                  </IconButton>
                </Box>
              )}
            </Box>
          </Box>
        )}
        {!storeId && (
          <Alert severity="info" sx={{ mt: 1 }}>
            {isEditMode
              ? "Vui lòng chọn cửa hàng ở trên để cập nhật phiếu nhập bánh trung thu"
              : "Vui lòng chọn cửa hàng ở trên để bắt đầu tạo phiếu nhập bánh trung thu"}
          </Alert>
        )}
      </Box>
      {/* Receipt layout */}
      {storeId && (
        <div className="receipt">
          <div className="header">
            <div className="logo">
              DOTI
              <br />
              COM
            </div>
            <div className="title">PHIẾU GIAO NHẬN BÁNH TRUNG THU</div>
            <div className="subtitle">20 20 30 90 96</div>
          </div>
          <div className="info-section">
            <div className="info-left">
              <div className="customer-row">
                <span className="customer-label">Khách hàng:</span>
                <input
                  type="text"
                  className="customer-input handwritten"
                  value={receipt.khachHang}
                  onChange={(e) =>
                    setReceipt({ ...receipt, khachHang: e.target.value })
                  }
                  placeholder="Nhập tên khách hàng"
                  disabled={!!storeId} /* disable khi đã chọn cửa hàng */
                  style={{
                    backgroundColor: storeId ? "#f5f5f5" : "transparent",
                    cursor: storeId ? "not-allowed" : "text",
                  }}
                />
              </div>
              <div className="date-row">
                Ngày: <span className="handwritten">{day}</span> tháng{" "}
                <span className="handwritten">{month}</span> năm{" "}
                <span className="handwritten">{year}</span>
              </div>
              {isEditMode && (
                <div className="edit-mode-indicator">
                  <strong>Chế độ: Chỉnh sửa phiếu</strong>
                </div>
              )}
            </div>
            <div className="info-right">
              <div>Ký hiệu: DTTT/BN</div>
              <div>Số: {receipt.soPhieu.split("-")[1]}</div>
            </div>
          </div>
          <div className="table-container">
            <table
              className="items-table"
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <thead>
                <tr>
                  <th className="code-col" style={{ width: "15%" }}>
                    Mã vt
                  </th>
                  <th className="name-col" style={{ width: "50%" }}>
                    Tên Mặt Hàng
                  </th>
                  <th className="qty-col" style={{ width: "15%" }}>
                    Số lượng
                  </th>
                  <th className="action-col" style={{ width: "20%" }}>
                    Thao tác
                  </th>
                </tr>
              </thead>
              <tbody>
                {receipt.items.length > 0 ? (
                  receipt.items.map((item, index) => {
                    const isHighlighted = highlightMatchingItems(item, index);
                    const isCurrentHighlight =
                      highlightedItems.length > 0 &&
                      highlightedItems[currentHighlightIndex]?.index === index;
                    return (
                      <tr key={`item-${index}`} data-item-index={index}>
                        <td
                          className={`code-cell ${isHighlighted ? "highlight" : ""
                            } ${isCurrentHighlight ? "current-highlight" : ""}`}
                        >
                          {item.maVt}
                        </td>
                        <td
                          className={`name-cell ${isHighlighted ? "highlight" : ""
                            } ${isCurrentHighlight ? "current-highlight" : ""}`}
                        >
                          {item.ten}
                        </td>
                        <td className="handwritten qty-cell">
                          <input
                            type="number"
                            inputMode="numeric"
                            value={item.soLuong || ""}
                            onChange={(e) => {
                              const newItems = [...receipt.items];
                              newItems[index] = {
                                ...newItems[index],
                                soLuong: e.target.value,
                              };
                              setReceipt({ ...receipt, items: newItems });
                            }}
                            onClick={(e) => e.target.select()}
                            onFocus={(e) => e.target.select()}
                            onKeyDown={handleQuantityKeyDown}
                            onBlur={handleQuantityBlur}
                            className={`qty-input ${isHighlighted ? "highlight" : ""
                              } ${isCurrentHighlight ? "current-highlight" : ""}`}
                            title="Số lượng"
                            min="1"
                          />
                        </td>
                        <td className="action-cell">
                          <IconButton
                            color="error"
                            size="small"
                            onClick={() => removeItem(index)}
                            title="Xóa sản phẩm"
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        fontStyle: "italic",
                        color: "#666",
                      }}
                    >
                      Chưa có sản phẩm nào. Vui lòng quét QR code để thêm sản
                      phẩm.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="total-section">
            <div className="status-row">
              <div className="status-item">
                <strong>Trạng thái: </strong>
                <span
                  className={`status-badge ${getReceiptStatus()
                    .toLowerCase()
                    .replace(/\s/g, "-")}`}
                >
                  {getReceiptStatus()}
                </span>
              </div>
              <div className="rdb-item">
                <strong>
                  Tổng số lượng:{" "}
                  {receipt.items.reduce(
                    (sum, item) => sum + (parseInt(item.soLuong) || 0),
                    0
                  )}
                </strong>
              </div>
            </div>
          </div>
          <div className="signature-section">
            {isAdmin && (
              <div className="signature-box">
                <div className="signature-title">
                  Kiểm soát BQD
                  <br />
                  (Ký, ghi rõ họ tên)
                </div>
                <button
                  className="confirm-btn"
                  onClick={(e) =>
                    confirmAction(e.target, "Đã kiểm soát BQD", true)
                  }
                  disabled={submitting}
                >
                  {submitting ? "Đang xử lý..." : "Xác nhận kiểm soát"}
                </button>
                <div className="status-text"></div>
              </div>
            )}
            <div className="signature-box">
              <div className="signature-title">Điều phối</div>
              <button
                className="confirm-btn"
                onClick={(e) =>
                  confirmAction(e.target, isEditMode ? "Đã cập nhật phiếu" : "Đã xác nhận gửi phiếu")
                }
                disabled={submitting}
              >
                {submitting ? (isEditMode ? "Đang cập nhật..." : "Đang gửi phiếu...") : (isEditMode ? "Cập nhật phiếu" : "Xác nhận gửi phiếu")}
              </button>
              <div className="status-text"></div>
            </div>
          </div>
        </div>
      )}
      <TrungThuQrScannerModal
        open={qrScannerOpen}
        onClose={() => {
          setQrScannerOpen(false);
          focusQrInput();
        }}
        onScan={(qrData, quantity) =>
          processQRCode(qrData, {
            showErrorModal: false,
            quantityOverride: quantity,
          })
        }
      />
      {/* Error Modal */}
      <Dialog
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: "#ffebee",
            border: "2px solid #f44336",
          },
        }}
      >
        <DialogTitle
          sx={{
            color: "#d32f2f",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Box
            sx={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              backgroundColor: "#f44336",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            !
          </Box>
          Lỗi
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{ color: "#d32f2f", fontWeight: 500 }}
          >
            {errorModalMessage}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: 2 }}>
          <Button
            onClick={() => {
              setErrorModalOpen(false);
              // Tự động focus lại vào QR input sau khi đóng modal lỗi
              setTimeout(() => {
                if (qrInputRef.current) {
                  qrInputRef.current.focus();
                }
              }, 100);
            }}
            variant="contained"
            color="error"
            fullWidth
            sx={{ fontWeight: "bold" }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {showScrollToBottom && (
        <Box
          sx={{
            position: "fixed",
            right: 20,
            bottom: 80,
            zIndex: 1300,
            "@media print": { display: "none" },
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            sx={{
              borderRadius: "50%",
              minWidth: 0,
              width: 48,
              height: 48,
              fontSize: 28,
              boxShadow: 3,
              p: 0,
            }}
            onClick={() => {
              if (bottomRef.current)
                bottomRef.current.scrollIntoView({ behavior: "smooth" });
              else
                window.scrollTo({
                  top: document.body.scrollHeight,
                  behavior: "smooth",
                });
            }}
            title="Cuộn xuống cuối trang"
          >
            ↓
          </Button>
        </Box>
      )}
      <style jsx>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: Arial, sans-serif;
          background-color: #f5f5f5;
          padding: 20px;
        }

        .receipt {
          max-width: 1200px;
          margin: 0 auto;
          background: white;
          padding: 20px;
          border: 2px solid #333;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          width: 100%;
        }

        .header {
          text-align: center;
          margin-bottom: 20px;
          position: relative;
        }

        .logo {
          position: absolute;
          left: 0;
          top: 0;
          width: 60px;
          height: 60px;
          background: linear-gradient(45deg, #ff6b35, #f7931e);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 12px;
        }

        .title {
          color: #d32f2f;
          font-size: 28px;
          font-weight: bold;
          margin-top: 10px;
          letter-spacing: 2px;
        }

        .subtitle {
          font-style: italic;
          color: #666;
          margin-top: 5px;
        }

        .info-section {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
          border-bottom: 1px solid #ccc;
          padding-bottom: 10px;
        }

        .info-left {
          flex: 1;
        }

        .info-right {
          text-align: right;
        }

        .customer-row {
          display: flex;
          flex-direction: column;
          gap: 5px;
          margin-bottom: 8px;
        }

        .customer-label {
          font-weight: bold;
        }

        .date-row {
          font-size: 11px;
        }

        .table-container {
          overflow-x: hidden;
          margin-bottom: 20px;
          width: 100%;
          -webkit-overflow-scrolling: auto;
        }

        .items-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 10px;
          table-layout: fixed !important;
          max-width: 100%;
        }

        .items-table th,
        .items-table td {
          border: 1px solid #333;
          padding: 6px 4px;
          text-align: left;
          word-wrap: break-word;
          vertical-align: top;
          overflow: visible;
          height: auto;
          min-height: 35px;
        }

        .items-table th {
          background-color: #ffcccb;
          font-weight: bold;
          text-align: center;
          position: sticky;
          top: 0;
          z-index: 10;
          font-size: 10px;
          height: 35px;
          line-height: 1.3;
          padding: 8px 4px;
          vertical-align: middle;
        }

        .code-cell {
          font-size: 14px;
          word-break: break-all;
          overflow: visible;
          white-space: normal;
          line-height: 1.2;
          vertical-align: top;
        }

        .name-cell {
          word-break: break-word;
          overflow: visible !important;
          text-overflow: initial !important;
          white-space: normal !important;
          font-size: 14px;
          line-height: 1.3;
          padding: 6px 4px !important;
          vertical-align: top;
          max-height: none !important;
          -webkit-line-clamp: none !important;
          -webkit-box-orient: initial !important;
          display: table-cell !important;
        }

        .qty-cell {
          text-align: center;
          vertical-align: middle;
          padding: 6px 4px !important; /* đảm bảo có padding để căn giữa */
        }

        .action-cell {
          text-align: center;
          vertical-align: middle;
        }

        .signature-section {
          display: flex;
          flex-direction: column;
          gap: 15px;
          margin-top: 20px;
          padding-top: 15px;
          border-top: 2px solid #333;
        }

        .signature-box {
          text-align: center;
          padding: 15px 10px;
          border: 1px solid #ddd;
          border-radius: 8px;
          background-color: #f9f9f9;
        }

        .signature-title {
          font-weight: bold;
          margin-bottom: 12px;
          color: #333;
          font-size: 11px;
          line-height: 1.3;
        }

        .confirm-btn {
          background: linear-gradient(45deg, #4caf50, #45a049);
          color: white;
          border: none;
          padding: 12px 16px;
          border-radius: 25px;
          cursor: pointer;
          font-size: 14px;
          font-weight: bold;
          transition: all 0.3s ease;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          width: 100%;
          min-height: 48px;
          touch-action: manipulation;
        }

        .confirm-btn:hover {
          background: linear-gradient(45deg, #45a049, #4caf50);
          transform: translateY(-1px);
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
        }

        .confirm-btn:active {
          transform: translateY(0);
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }

        .confirm-btn:disabled {
          background: #cccccc !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: none !important;
        }

        .confirm-btn.confirmed {
          background: linear-gradient(45deg, #2196f3, #1976d2);
          cursor: default;
        }

        .confirm-btn.confirmed:hover {
          transform: none;
          background: linear-gradient(45deg, #2196f3, #1976d2);
        }

        .status-text {
          font-size: 10px;
          margin-top: 8px;
          color: #666;
          font-style: italic;
          line-height: 1.2;
        }

        .total-section {
          margin-top: 15px;
          padding: 10px;
          background-color: #f0f0f0;
          border-radius: 5px;
        }

        .status-row {
          display: flex;
          flex-direction: column;
          gap: 8px;
          align-items: flex-start;
        }

        .status-item {
          font-size: 11px;
        }

        .rdb-item {
          font-size: 11px;
          align-self: flex-end;
        }

        .highlight {
          background-color: #fffde7;
          box-shadow: 0 0 5px rgba(255, 193, 7, 0.5);
          font-weight: bold;
        }

        .current-highlight {
          background-color: #fff3c4 !important;
          box-shadow: 0 0 10px rgba(255, 152, 0, 0.8) !important;
          border: 2px solid #ff9800 !important;
        }

        .scroll-highlight {
          animation: pulseHighlight 1s ease-in-out;
        }

        @keyframes pulseHighlight {
          0% {
            transform: scale(1);
            box-shadow: 0 0 10px rgba(255, 152, 0, 0.8);
          }
          50% {
            transform: scale(1.02);
            box-shadow: 0 0 20px rgba(255, 152, 0, 1);
          }
          100% {
            transform: scale(1);
            box-shadow: 0 0 10px rgba(255, 152, 0, 0.8);
          }
        }

        input.highlight {
          background-color: #fffde7;
          border-bottom: 2px solid #ffc107 !important;
        }

        input.current-highlight {
          background-color: #fff3c4 !important;
          border-bottom: 2px solid #ff9800 !important;
        }

        /* Very small mobile screens (width <= 360px) */
        @media (max-width: 360px) {
          body {
            padding: 4px;
            overflow-x: hidden;
          }

          .receipt {
            padding: 8px;
            border-width: 1px;
            overflow-x: hidden;
          }

          .logo {
            width: 40px;
            height: 40px;
            font-size: 8px;
          }

          .title {
            font-size: 14px;
            letter-spacing: 0.5px;
            margin-left: 45px;
          }

          .subtitle {
            font-size: 10px;
          }

          .info-section {
            font-size: 10px;
            margin-bottom: 12px;
            padding-bottom: 8px;
            gap: 6px;
          }

          .customer-row {
            gap: 3px;
            margin-bottom: 6px;
          }

          .customer-input {
            font-size: 10px;
            padding: 3px 6px;
          }

          .date-row {
            font-size: 9px;
          }

          .info-right {
            font-size: 10px;
          }

          .table-container {
            margin-bottom: 15px;
            overflow-x: hidden;
          }

          .items-table {
            font-size: 8px;
            table-layout: fixed;
            width: 100%;
          }

          .items-table th,
          .items-table td {
            padding: 4px 2px;
            overflow: visible;
            height: auto;
            min-height: 30px;
          }

          .name-cell {
            font-size: 14px;
            line-height: 1.2;
            padding: 4px 2px !important;
          }

          .qty-input {
            width: 50px; /* nhỏ hơn trên mobile */
            font-size: 14px;
            min-height: 24px;
          }

          /* Tablet styles */
          @media (min-width: 768px) {
            body {
              padding: 20px;
              overflow-x: hidden;
            }

            .receipt {
              padding: 20px;
              overflow-x: hidden;
            }

            .logo {
              width: 60px;
              height: 60px;
              font-size: 12px;
            }

            .title {
              font-size: 24px;
            }

            .subtitle {
              font-size: 14px;
            }

            .info-section {
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              font-size: 14px;
            }

            .customer-row {
              flex-direction: row;
              align-items: center;
              gap: 8px;
            }

            .table-container {
              overflow-x: hidden;
            }

            .items-table th,
            .items-table td {
              padding: 8px 6px;
              min-height: 40px;
            }

            .name-cell {
              font-size: 14px;
              line-height: 1.4;
            }

            .qty-input {
              width: 80px; /* lớn hơn một chút trên tablet */
              font-size: 14px;
            }

            .signature-section {
              flex-direction: row;
              justify-content: space-around;
            }

            .signature-title {
              font-size: 13px;
            }

            .confirm-btn {
              font-size: 14px;
            }

            .status-row {
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            }

            .status-item,
            .rdb-item {
              font-size: 13px;
            }
          }

          /* Desktop styles */
          @media (min-width: 1024px) {
            .receipt {
              max-width: 1200px;
              overflow-x: hidden;
            }

            .title {
              font-size: 28px;
            }

            .items-table {
              font-size: 12px;
            }

            .signature-section {
              gap: 20px;
            }
          }

          @media print {
            body {
              padding: 0;
              overflow-x: hidden;
            }
            .receipt {
              max-width: 100%;
              border: none;
              box-shadow: none;
              padding: 10px;
              overflow-x: hidden;
            }
            .qty-input {
              border-bottom: 1px solid #999;
            }
            .signature-section {
              flex-direction: row;
            }
            .table-container {
              overflow-x: hidden;
            }
          }

          /* Global prevent horizontal scroll */
          html,
          body {
            overflow-x: hidden;
            max-width: 100vw;
          }

          * {
            box-sizing: border-box;
          }

          .MuiContainer-root {
            overflow-x: hidden !important;
          }

          .info-section {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;
          }

          .customer-row {
            flex-direction: row;
            align-items: center;
            gap: 8px;
          }

          .table-container {
            overflow-x: hidden;
          }

          /* SỬA: Thêm width cho action-col trong tablet */
          .code-col,
          .code-cell {
            width: 15% !important;
          }

          .name-col,
          .name-cell {
            width: 50% !important;
          }

          .qty-col,
          .qty-cell {
            width: 15% !important;
          }

          .action-col,
          .action-cell {
            width: 20% !important;
          }

          .signature-section {
            flex-direction: row;
            justify-content: space-around;
          }

          .signature-title {
            font-size: 13px;
          }

          .confirm-btn {
            font-size: 14px;
          }

          .status-row {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }

          .status-item,
          .rdb-item {
            font-size: 13px;
          }
        }

        /* Desktop styles */
        @media (min-width: 1024px) {
          .receipt {
            max-width: 1200px;
            overflow-x: hidden;
          }

          .title {
            font-size: 28px;
          }

          .items-table {
            font-size: 12px;
          }

          .signature-section {
            gap: 20px;
          }
        }

        @media print {
          body {
            padding: 0;
            overflow-x: hidden;
          }
          .receipt {
            max-width: 100%;
            border: none;
            box-shadow: none;
            padding: 10px;
            overflow-x: hidden;
          }
          .qty-input {
            border-bottom: 1px solid #999;
          }
          .signature-section {
            flex-direction: row;
          }
          .table-container {
            overflow-x: hidden;
          }
        }

        /* Global prevent horizontal scroll */
        html,
        body {
          overflow-x: hidden;
          max-width: 100vw;
        }

        * {
          box-sizing: border-box;
        }

        .MuiContainer-root {
          overflow-x: hidden !important;
        }

        .qty-input {
          width: 70px; /* giảm từ 100% xuống 70px */
          border: none;
          background: transparent;
          border-bottom: 1px dashed #999;
          color: #0066cc;
          font-weight: bold;
          text-align: center;
          padding: 4px 2px;
          font-family: "Courier New", monospace;
          font-size: 11px;
          min-height: 28px;
          -webkit-appearance: none;
          -moz-appearance: textfield;
          margin: 0 auto; /* căn giữa */
          display: block; /* để margin auto hoạt động */
        }

        .customer-input {
          border: none;
          border-bottom: 1px dashed #999;
          outline: none;
          padding: 4px 8px;
          width: 100%;
          margin-top: 4px;
          font-size: 12px;
        }

        .customer-input:disabled {
          background-color: #f5f5f5 !important;
          color: #666 !important;
          cursor: not-allowed !important;
        }

        .edit-mode-indicator {
          font-size: 10px;
          color: #ff9800;
          margin-top: 4px;
          font-style: italic;
        }

        @media (max-width: 768px) {
          body {
            padding: 6px;
          }

          .receipt {
            padding: 10px;
            border-width: 1px;
            font-size: 13px;
          }

          .header {
            margin-bottom: 10px;
          }

          .logo {
            width: 42px;
            height: 42px;
            font-size: 9px;
            position: relative;
            margin: 0 auto 8px;
          }

          .title {
            font-size: 21px !important;
            line-height: 1.15;
            letter-spacing: 0;
            margin-left: 0 !important;
            margin-top: 0;
          }

          .subtitle {
            font-size: 12px;
          }

          .info-section {
            flex-direction: column;
            gap: 6px;
            margin-bottom: 10px;
            padding-bottom: 8px;
            font-size: 13px;
            line-height: 1.45;
          }

          .info-left,
          .info-right {
            text-align: left;
          }

          .customer-row {
            gap: 4px;
            margin-bottom: 6px;
          }

          .customer-input {
            font-size: 13px;
            min-height: 30px;
            padding: 4px 6px;
          }

          .table-container {
            margin-bottom: 14px;
            overflow-x: hidden;
          }

          .items-table {
            min-width: 100%;
            font-size: 12px;
            table-layout: fixed;
          }

          .items-table th,
          .items-table td {
            padding: 5px 4px;
            min-height: 32px;
          }

          .items-table th {
            font-size: 11px;
            padding: 6px 4px;
          }

          .code-cell,
          .name-cell {
            font-size: 13px;
            line-height: 1.25;
          }

          .qty-input {
            width: 52px;
            min-height: 28px;
            font-size: 13px;
            padding: 3px 1px;
          }

          .total-section {
            margin-top: 14px;
            padding: 8px;
            font-size: 12px;
            text-align: left;
          }

          .status-row {
            gap: 6px;
          }

          .status-item,
          .rdb-item {
            font-size: 12px;
          }

          .signature-section {
            flex-direction: row;
            align-items: stretch;
            justify-content: space-between;
            gap: 6px;
            margin-top: 14px;
            padding-top: 10px;
          }

          .signature-box {
            flex: 1 1 0;
            min-width: 0;
            padding: 8px 4px;
            margin-bottom: 0;
            border-radius: 6px;
          }

          .signature-title {
            font-size: 10px;
            line-height: 1.2;
            margin-bottom: 7px;
          }

          .confirm-btn {
            min-height: 34px;
            padding: 6px 4px;
            border-radius: 16px;
            font-size: 10px;
            line-height: 1.15;
            white-space: normal;
            overflow-wrap: anywhere;
          }

          .status-text {
            font-size: 9px;
            line-height: 1.2;
          }
        }

        @media (max-width: 360px) {
          .receipt {
            padding: 8px 5px;
          }

          .title {
            font-size: 19px !important;
          }

          .items-table {
            font-size: 11px;
          }

          .items-table th,
          .items-table td {
            padding: 4px 2px;
          }

          .code-cell,
          .name-cell {
            font-size: 12px;
          }

          .qty-input {
            width: 46px;
            font-size: 12px;
            min-height: 26px;
          }

          .signature-section {
            gap: 4px;
          }

          .signature-box {
            padding: 6px 3px;
          }

          .signature-title,
          .confirm-btn {
            font-size: 9px;
          }

          .status-text {
            font-size: 8px;
          }
        }
      `}</style>
    </Box>
  );
};

export default NewPhieuNhapTT;
